<template>
  <div class="signboard">
    <h1 class="title">Signboard generator</h1>
    <app-cells>
      <app-textarea
          v-model="signboard_text"
          rows="5"
          placeholder="Write a signboard"
      />
    </app-cells>
    <app-cells>
      <app-button @click.native="onSignboardPrint" ref="print" theme="warn" :disabled="!signboard_text">Print</app-button>
      <app-button @click.native="onSignboardDownload" ref="download" :disabled="!signboard_text">Download</app-button>
    </app-cells>
  </div>
</template>

<script>
import { postTransferSingleSignboardPrint } from '@/http'

export default {
  name: 'Signboard',
  data() {
    return {
      signboard_text: '',
    }
  },
  methods: {
    onSignboardPrint() {
      this.$refs.print.preload = true
      postTransferSingleSignboardPrint('print', { text: this.signboard_text })
        .finally(() => { this.$refs.print.preload = false })
        .then(response => { window.open(response.data) })
    },
    onSignboardDownload() {
      this.$refs.download.preload = true
      postTransferSingleSignboardPrint('download', { text: this.signboard_text })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Signboard - ${this.signboard_text}.pdf`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
          this.$refs.download.preload = false
        })
    },
  }
}
</script>

<style lang="sass" scoped>
.signboard
  max-width: 400px
</style>
